<script>
import Rodape from '@/components/rodape.vue';
import Menu from '/src/components/header.vue';

export default {
    name: 'Contato',
    components: {
        Menu,
    }
}
</script>

<template>
    <Menu></Menu>
    <div class="contatos">
        <p class="nossos_contatos">NOSSOS CONTATOS</p>
        <div class="geral">
            <p class="titulo">Nacional Indústria Metalúrgica Ltda</p>
            <div class="bloco4">
                <div class="bloco3">
                    <div class="contato">
                        <img class="logotipo" src="../assets/imagens/phone.png" alt="">
                        <p>+ 55 (27) 3441-2542</p>
                    </div>
                    <div class="contato">
                        <img class="logotipo" src="../assets/imagens/email.png" alt="">
                        <p>administrativo@nacionalindustria-es.com.br</p>
                    </div>
                    <div class="contato">
                        <img class="logotipo" src="../assets/imagens/local.png" alt="">
                        <p>R. CASTELO, Nº 1214 - BLOCO B - JARDIM LIMOEIRO - SERRA/ES.</p>

                    </div>
                    <div class="contato">
                        <p class="cep">CEP: 29164-030</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
    .contatos {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: baseline;
        width: 100vw;
        min-height: 60vh;
        background-color: #fff;
    }

    .menu {
        position: relative;
        width: 100%;
        z-index: 1;
    }

    .rodape {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .bloco4 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

    }

    .bloco3 {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        font-size: 0.8rem;
        gap: 15px;

    }

    .nossos_contatos {
        color: #2e74c4;
        letter-spacing: 2px;
        font-size: 1.2rem;
        width: 100%;
        text-align: center;
        margin: 2rem 0rem 5rem 0rem;
        font-weight: bold;
    }

    .contato {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .logotipo {
        color: #fff;
        width: 1rem;
    }

    .titulo {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 2rem 0rem;
        color: #444;
    }

    .geral {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        border: 0px solid #444;
        background-color: #fff;
        color: #444;
        padding: 1rem;
        border-radius: 10px;
        width: 95%;
        box-shadow: 0px 0px 10px 0px #4444446c;

    }

    .cep {
        text-align: center;
        margin-left: 1.6rem;
    }

    .imagemcontatos {
        width: 10rem;
    }
}

@media (min-width: 901px) {
    .contatos {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: baseline;
        width: 100vw;
        min-height: 83vh;
        background-color: #fff;
    }

    .menu {
        position: relative;
        width: 100%;
        z-index: 1;
    }

    .rodape {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .bloco4 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

    }

    .bloco3 {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        font-size: 1rem;
        gap: 20px;

    }
    .nossos_contatos {
        color: #2e74c4;
        letter-spacing: 2px;
        font-size: 1.2rem;
        width: 100%;
        text-align: center;
        margin: 2rem 0rem 2rem 0rem;
        font-weight: bold;
    }
    .contato {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .logotipo {
        color: #444;
        width: 2rem;
    }

    .titulo {
        font-size: 1.2rem;
        font-weight: bold;
        margin: 2rem 0rem;
        color: #444;
        letter-spacing: 2px;
    }

    .geral {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        color: #444;
        padding: 2rem;
        border-radius: 10px;
        box-shadow: 0px 0px 10px 0px #4444446c;
    }

    .cep {
        text-align: center;
        margin-left: 2.6rem;
    }

    .imagemcontatos {
        width: 10rem;
    }
}
</style>